import { Calendar } from '@webnuts/shared-components';
import styled from '../styled-components';
export default styled(Calendar).withConfig({
  displayName: "Calendar",
  componentId: "sc-21pdlj-0"
})(["", "{font-family:'Lato';}", "{font-family:'Lato';}"], Calendar.HeaderLabel, Calendar.DateCell);